const BASE_URL =
  "https://opendata.paris.fr/api/v2/catalog/datasets/que-faire-a-paris-/records";

async function request(url, signal) {
  const res = await fetch(url, { signal });
  const data = await res.json();
  if (!res.ok || data.error_code) {
    throw new Error(data.message || `Erreur API (${res.status})`);
  }
  return data;
}

export function fetchEvents(
  { limit = 5, offset = 0, orderBy, search, where } = {},
  signal
) {
  const params = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  if (orderBy) params.set("order_by", orderBy);
  if (search) params.set("search", search);
  if (where) params.set("where", where);
  return request(`${BASE_URL}?${params.toString()}`, signal);
}

export function fetchEvent(id, signal) {
  return request(`${BASE_URL}/${encodeURIComponent(id)}`, signal);
}
